import { api } from './api';

const getByKeys = async (data, lang) => {
    const response = await api({
        url: 'TranslateMaps/getByKeys',
        method: 'GET',
        params: {
            dataSource: 1,
            ...data,
        },
        headers: {
            'Content-Language': lang,
        },
    });
    return response.data;
};

const getPagedList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `TranslateMaps/getPagedList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...body,
        },
    });
    return response.data;
};

const languageUpdate = async (data) => {
    const response = await api({
        url: `TranslateMaps/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const languageUpdateRedis = async () => {
    const response = await api({
        url: `TranslateMaps/translateMapToRedis`,
        method: 'GET',
        headers: {
            'Content-Language': 'tr',
        },
    });
    return response.data;
};

const translateMapsServices = {
  getByKeys,
  getPagedList,
  languageUpdate,
  languageUpdateRedis,
};

export default translateMapsServices;
